module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_chapel-a5cea09f1c1ec8b8d731b045e7895b06.webp";